import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'
import BrandFilterModal from '../BrandFilterModal'

const BrandLines = ({
  placeholders: {
    leftContent = [],
    rightContent = []
  } = {},
  title,
  hasActiveVehicle,
  addVehicleHandler
}) =>
  <Wrapper>
    <Title data-at-brand-lines-title headline_narrow>{ title }</Title>
    <Filters>
      <BrandFilterModal />
      { leftContent }
    </Filters>
    <Results>
      { rightContent }
    </Results>
    {
      !hasActiveVehicle &&
      <ShopByVehicleWrapper>
        <ShopByVehicle
          data-at-shop-tires-by-vehicle-button
          onClick={ addVehicleHandler }>
          Shop Tires by vehicle
        </ShopByVehicle>
      </ShopByVehicleWrapper>
    }
  </Wrapper>

export default BrandLines

BrandLines.propTypes = {
  addVehicleHandler: PropTypes.func,
  hasActiveVehicle: PropTypes.bool,
  placeholders: PropTypes.shape({
    leftContent: PropTypes.arrayOf(PropTypes.node),
    rightContent: PropTypes.arrayOf(PropTypes.node)
  }),
  title: PropTypes.string
}

const Wrapper = styled.div`
  margin-bottom: 30px;
  padding: 0 17px;
  ${Media.desktop`
    margin: 0 auto 40px auto;
    padding: 15px 0 0;
  `}
`

const Title = styled.h1`
  margin: 0 0 25px;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(20, 900)}
  ${Media.desktop`
    font-size: 34px;
  `}
`

const Filters = styled.div`
  display: block;
  ${Media.desktop`
    display: table-cell;
    min-width: 228px;
    padding-right: 24px;
    vertical-align: top;
  `}
`

const Results = styled.div`
  ${Media.mobile`
    margin-top: 42px;
  `}
  ${Media.desktop`
    display: table-cell;
    width: 100%;
    padding-left: 15px;
  `}
`

const ShopByVehicleWrapper = styled.div`
  margin-top: 30px;
  text-align: center;
`

const ShopByVehicle = styled(Button)`
  ${Media.mobile`
    width: 100%;
  `}
`
